import { LogoTypeKey } from 'interactive/logo-types';
import { useState } from 'react';

export interface AppState {
    step?: number;
    industry?: string;
    logoTypes?: LogoTypeKey[];
    name?: string;
}

export default function useAppState(key: string, initialValue: AppState) {
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const item = window.localStorage.getItem(key);

            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            // TODO: Handle read error if we think it's necessary or Bugsnag it
            return initialValue;
        }
    });

    const setValue = (value: any) => {
        try {
            const valueToStore = value instanceof Function ? value(storedValue) : value;

            setStoredValue(valueToStore);

            window.localStorage.setItem(key, JSON.stringify(valueToStore));
        } catch (error) {
            // TODO: Handle write error if we think it's necessary or Bugsnag it
        }
    };

    return [storedValue, setValue];
}

export function clearAppState(key: string) {
    window.localStorage.removeItem(key);
}
